export default function MainSection() {
  return (
    <section className="bg-white px-4 py-7">
      <div className="flex flex-col items-center gap-2.5 mx-auto">
        {/* 베이커리 이미지 */}
        <div className="w-[110px] h-[108px] relative">
          <img src="/assets/bakery-image.png" alt="공세계 베이커리" className="w-full h-full object-cover" />
        </div>

        {/* 인스타그램 링크 */}
        <a href="https://www.instagram.com/gongsegae/" target="_blank">
          <div className="flex items-center text-sm font-medium text-gray-500 gap-1 p-1.5 bg-gray-100 rounded-md">
            @gongsegae
          </div>
        </a>

        {/* 설명 텍스트 */}
        <p className="text-md font-medium text-gray-700 text-center leading-[1.57] whitespace-pre-line">
          예약 신청 후 입금을 완료 하시면 예약이 확정 됩니다.{'\n'}
          궁금하신게 있으시면 인스타 DM 주세요!
        </p>
      </div>
    </section>
  );
}
